import {useResponsive} from '../../lib/useResponsive';
import {Link, RouterLink} from '../ui/Link';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faClose} from '@fortawesome/free-solid-svg-icons';
import {useContext, useState} from 'react';
import {UserContext, hasAccess} from '../../context/UserProvider';
import {routeUrls, routes} from '../../routes';
import {getDateFormat} from '../../lib/dateUtils';
import {format} from 'date-fns';
import {useAuth0} from "@auth0/auth0-react";
import {useMsal} from "@azure/msal-react";

export const Navigation = () => {
    const {isMobile} = useResponsive();
    const [isOpen, setIsOpen] = useState(false);
    const {userRole} = useContext(UserContext);
    const auth0 = useAuth0();
    const msal = useMsal();

    const email = !auth0.isAuthenticated ? msal.accounts[0].username : auth0.user?.name

    const logout = !auth0.isAuthenticated ? () => {
        msal.instance.logout()
    } : () => {
        auth0.logout()
    };

return (
    <nav
        className={`fixed flex flex-col w-full h-full bg-secondary px-3 py-6 md:p-6 max-md:h-[80px] md:w-[300px] justify-center`}>
        <div className="flex justify-between items-center gap-6">
            <RouterLink href={routeUrls.DASHBOARD} hideAnchorIcon>
                <img src="https://houseofcohedron.nl/wp-content/uploads/2024/09/house-of-cohedron.svg" alt="Cohedron logo"
                     className="max-md:max-h-8"/>
            </RouterLink>

            <button
                className="relative items-center justify-center md:hidden rounded-md max-md:-mr-2 w-10 h-10"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="absolute -inset-0.5"/>
                <span className="sr-only">Open main menu</span>
                {isOpen ? (
                    <FontAwesomeIcon icon={faClose} className="p-2 text-3xl text-primary"/>
                ) : (
                    <FontAwesomeIcon icon={faBars} className="p-2 text-3xl text-primary"/>
                )}
            </button>
        </div>

        <div
            className={`max-md:bg-white flex-col flex-1 fixed md:relative flex inset-0 max-md:top-[80px] px-3 py-6 md:p-0 ${
                isOpen ? 'transition-all duration-300 ease-in-out' : ''
            }`}
            style={
                isMobile
                    ? {
                        width: isOpen ? '100%' : '0',
                        visibility: isOpen ? 'visible' : 'hidden',
                        opacity: isOpen ? '1' : '0',
                    }
                    : {}
            }
        >
            <div className="flex md:my-auto h-full">
                <div className="flex flex-col gap-6 w-full">
                    {routes
                        .filter((x) => hasAccess(userRole, x.accessLevel)) // Filter out routes that the user doesn't have access to
                        .filter((x) => (!x.visibility || x.visibility === userRole)) // Filter out routes that should not be visible to other roles
                        .map((link, index) => (
                            <RouterLink
                                href={link.path}
                                key={index}
                                className={`${index === 0 ? 'md:mt-auto' : ''}`}
                                onClick={() => {
                                    isMobile && setIsOpen(!isOpen);
                                }}
                            >
                                {link.title}
                            </RouterLink>
                        ))}

                    <div className="w-full border-t-[1px] border-primary"></div>
                    <Link href="mailto:ecosaver@cohedron.nl" className="md:mb-auto">Hulp nodig?</Link>

                    <Link href="#" className="md:mt-auto" onClick={() => logout()}>
                        Uitloggen
                    </Link>
                    <div className="w-full border-t-[1px] border-primary"></div>
                    <div className="flex flex-col gap-2  pb-10 max-md:mt-auto max-md:text-center">
                        <div className="text-primary text-sm">{email}</div>
                        <div className="text-primary text-sm">Bijgewerkt tot {format(new Date(), getDateFormat())}</div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
);
}
;
